import AbstractOperatorApplicationPlatform from "~/operatorApplication/ts/platform/AbstractOperatorApplicationPlatform";

export default abstract class AbstractOperatorApplicationDesktopPlatform extends AbstractOperatorApplicationPlatform {
    abstract get isWindows(): boolean;

    abstract get isLinux(): boolean;

    abstract get isMac(): boolean;
}
